import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { FeatureFlag, RoutingKey } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import { getState, select } from '@swf/core/store';

/**
 * API to communicate with the SportsBook legacy
 */
export function useSportsBookExchangeAPI() {
  const state = getState();
  const lang = select.locale.get(state);
  const { routes } = useSelector(select.page.getMeta);
  const exchangePath = (routes && routes[RoutingKey.SportsExchange]) || '';
  const isExchangeEnabled = useFeature(FeatureFlag.EnableExchange);
  const isEnableATSExchangeBetsLink = useFeature(FeatureFlag.EnableATSExchangeBetsLink);
  const isEmbedded = useSelector(select.site.isEmbedded);

  useEffect(() => {
    window.sportsbook = {
      isEmbedded,
      isExchangeEnabled: isExchangeEnabled && isEnableATSExchangeBetsLink,
      exchangePath,
      exchangeMyBetsPath: 'customer/account/mybets/unmatched/1',
      lang
    };
  }, [exchangePath, isExchangeEnabled, isEnableATSExchangeBetsLink, isEmbedded, lang]);
}
